export enum TimelineEnum {
  RequestListed = 10,
  ReviewDeal = 20,
  PaymentInProgress = 30,
  PaymentCompleted = 40,
  ShipmentCompleted = 50
}
